import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Icon } from "@iconify/react";
import { Helmet } from "react-helmet-async";
import BlogContactForm from '../../Components/Blogs/blog-contactform';
import BlogFaqs from '../../Components/Blogs-faqs/blogsFaqs';

const BlogDetails = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [meta, setMeta] = useState({
    title: '',
    description: '',
    keywords: '',
    url: window.location.href,
  });

  useEffect(() => {
  // 1. Fetch post by slug
  fetch(`https://blogs.eyantra.com/wp-json/wp/v2/posts?slug=${slug}&_embed=1`)
    .then(res => res.json())
    .then(data => {
      if (data.length > 0) {
        const currentPost = data[0];
        setPost(currentPost);

        // 2. Fetch custom meta from Meta REST API
        fetch(`https://blogs.eyantra.com/wp-json/meta-api/v1/post-meta?slug=${slug}`)
          .then(res => res.json())
          .then(metaData => {
            const title = metaData.meta_title || currentPost.title.rendered;
            const description = metaData.meta_description || '';
            const keywords = metaData.meta_keywords || '';

            setMeta({
              title,
              description,
              keywords,
              url: window.location.href,
            });

            // Update <title>
            document.title = title;

            // Update description meta tag
            let descTag = document.querySelector("meta[name='description']");
            if (!descTag) {
              descTag = document.createElement('meta');
              descTag.name = 'description';
              document.head.appendChild(descTag);
            }
            descTag.content = description;

            // Update keywords meta tag
            let keywordsTag = document.querySelector("meta[name='keywords']");
            if (!keywordsTag) {
              keywordsTag = document.createElement('meta');
              keywordsTag.name = 'keywords';
              document.head.appendChild(keywordsTag);
            }
            keywordsTag.content = keywords;
          })
          .catch(err => console.error("Error fetching meta:", err));
      } else {
        console.error('Post not found');
      }
    })
    .catch(err => console.error('Error fetching post:', err));
}, [slug]);

  if (!post) return <p>Loading...</p>;

  const imageUrl = post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '/assests/blogBg.png';
  const authorName = post._embedded?.author?.[0]?.name;
  const publishDate = new Date(post.date).toLocaleDateString();

  return (
    <>
      {/* SEO Meta from Meta REST API */}
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <link rel="canonical" href={meta.url} />
      </Helmet>

      <div className='container-fluid mt-4' id='bgBlog' style={{ backgroundImage: "url(/assests/blogBg.png)", backgroundSize: 'cover' }}>
        <Container className="h-100">
          <div className='d-flex justify-content-center align-items-center flex-column h-100 text-center'>
            <h1 className='fs-48 fw-bold'>Blogs</h1>
            <p className='text-center'>
              Read the latest articles, blogs, case studies, and many more published by eYantra
            </p>
          </div>
        </Container>
      </div>

      <div className='container-fluid bg-light py-5'>
        <Container>
          <Row>
            <Col md={8} className="mx-auto px-0">
              {imageUrl && (
                <img src={imageUrl} alt={post.title.rendered} className="img-fluid mb-4 rounded w-100 border-eY" />
              )}
              <Row className='align-items-center justify-content-start d-flex px-2'>
                <Col md={1} className='col-1 p-0 mx-1 text-center'>
                  <Icon icon="ic:round-person" width="32" height="32" className='rounded-circle border boder-secondary' />
                </Col>
                <Col md={5} className='col-6 p-0 mx-1'>
                  <strong className='p-0 m-0'>{authorName}</strong>
                  <br />
                  <small>Posted On {publishDate}</small>
                </Col>
              </Row>
              <h5 className='fs-32 fw-bold pt-4' dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
              <div className='pt-4' id="blogContent" dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
                <div dangerouslySetInnerHTML={{ __html: post.yoast_head_json?.faq || '' }} />

              <BlogFaqs />
            </Col>
            <Col md={4}>
              <BlogContactForm />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default BlogDetails;
